import type React from 'react';

import { Handle, Position } from '@xyflow/react';
import { useTranslate } from 'react-admin';

import NodeIcon from '../../components/NodeIcon';
import NodeHeader from '../NodeHeader';
import NodeWrapper from '../NodeWrapper';

export default function CallMeNode(): React.ReactElement {
  const translate = useTranslate();

  return (
    <NodeWrapper condensed>
      <NodeHeader icon={<NodeIcon name='call_me' title={translate('callflows.nodes.call_me.name')} />} condensed />
      <Handle type='target' position={Position.Left} id='call_me-target' />
      <Handle type='source' position={Position.Right} id='call_me-source' />
    </NodeWrapper>
  );
}
